<section id="main-section">
    <div class="leaderboard__wrap">
        <div class="d-flex leaderboard--banner">
            <div class="leaderboard--banner-inner">
                <div>
                    <h3>
                        Leaderboard
                    </h3>
                    <p *ngIf="userData?.length">
                        <strong>{{userData.length?userData[0].firstName:'N/A' }}
                            {{userData.length?userData[0].lastName:''}},</strong>
                        your current rank is : <span class="current--rank">#{{userData.length?userData[0].activationRank:'N/A'}}
                            <div *ngIf="userData[0].activationRank > 3 && userData[0].activationRank < 21">
                                <ng-container><sup>th</sup></ng-container>
                            </div>
                            <!-- <div *ngIf="!(userData[0].activationRank > 3 && userData[0].activationRank < 21)"
                                [ngSwitch]="userData[0].activationRank % 10">
                                <ng-container *ngSwitchCase="1"><sup>st</sup></ng-container>
                                <ng-container *ngSwitchCase="2"><sup>nd</sup></ng-container>
                                <ng-container *ngSwitchCase="3"><sup>rd</sup></ng-container>
                                <ng-container *ngSwitchDefault><sup>th</sup></ng-container>
                            </div> -->
                        </span>
                    </p>
                    <p style="margin-top:10px;font-size: 16px; text-transform: capitalize;">
                        How is this calculated? <span (click)="openDescriptionModal()" style="margin-top: 4px;position: absolute;margin-left: 5px;font-size: 14px !important;" class="icon-info-circle font-10 lock-icon"></span>
                    </p>
                </div>
                
                <div>
                    <img src="./../../../../assets/images/upgradRed/leaderboard_banner-Image.png" alt="Notes and Bookmarks">
                </div>
            </div>
        </div>
        <article class="leaderboard" *ngIf="userList.length">
            <div class="leaderboard__head d-flex">
                <div class="rank">Rank</div>
                <div class="leaderboard__col d-flex">
                    <div class="name">Name</div>
                    <div class="name">Program Progress</div>
                    <div class="name mob--show">Name & Progress</div>
                </div>
            </div>
            <!-- leaderboard details -->

            <div class="leaderboard__table d-flex flex-column" (scroll)='checkthis($event)'>
                <div class="leaderboard__row d-flex align-items-center" *ngFor="let user of userList;index as i;">
                    <div class="leaderboard--rank d-flex align-items-center">
                        <span>{{ordinalNumber(user.activationRank)}}</span>
                        <img src="{{user.profilePic?user.profilePic: '/assets/images/user.svg'}}" />

                    </div>
                    <div class="leaderboard__col d-flex">
                        <div class="leaderboard--name"> {{user.firstName+" "+user.lastName}}
                            <span *ngIf="user.status == 'Green'">Superstar</span>
                            <span *ngIf="user.status == 'Yellow'" class="achiever">Achiever</span>
                            <span *ngIf="user.status == 'Red'" class="novice">Novice</span>
                        </div>
                        <div class="leaderboard--progress d-flex align-items-center">
                            <div class="progress__wrap">
                                <div class="progress__color" [ngClass]="{
                                'progress__color-good':(user.status == 'Green'),
                                'progress__color-average':(user.status == 'Yellow'),
                                'progress__color-poor':(user.status == 'Red')}"
                                    [ngStyle]="{'width':user.progress+'%'}"></div>
                                <div class="progress__bg" ></div>
                            </div>
                            <p>{{user.progress | number : '1.0-0'}}%</p>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center" *ngIf="loadingImg">
                    <div class="col-12">
                        <img src="/assets/images/gif/animation_loader.gif" class="loadergif">
                    </div>
                </div>
            </div>

        </article>
        <article class="empty__leaderboard d-flex justify-content-between align-items-center" *ngIf="!userList.length">
            <div class="d-flex align-items-center justify-content-center flex-column">
                <img src="assets/images/revamp/leaderboard.png" />
                <p>Leaderboard will appear once 5 of your peers have completed the first module.</p>
                <button type="button" class="light-color link-no-underline blue--button pd-t10 pd-b10 pd-l20 pd-r20"
                    (click)="redirectMethod()">Go to dashboard</button>
            </div>
        </article>
    </div>
</section>
<div class="position-relative" *ngIf="showLoaderDashboard">
    <div class="d-flex align-items-center justify-content-center certificate-loader">
        <div>
            <img class="mx-auto loader-gif" src="assets/images/upgradRed/upgradLoader.gif" style="margin: 0 auto;">
            <!-- <div>Your report is downloading...</div> -->
        </div>
    </div>
</div>
<app-leaderboard-information-modal *ngIf="showDescriptionModal" [desc]="'test descc'" (modelOpen)="closeDescriptionModel($event)"></app-leaderboard-information-modal>

<!-- <app-dashboard-description-modal *ngIf="showDescriptionModal" [desc]="prog?.description" (modelOpen)="closeDescriptionModel($event)"></app-dashboard-description-modal> -->